import FieldDependencies from "../dependencies/dependencies"
import FieldConfig from "../../../proto/field-config"
import ItemModelV2 from "../../../../model2/item2/item-model"
import {DependencyType} from "../../../../model2/dependency/const"

export default class FieldSuccessors extends FieldDependencies {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Dependants"
        this.icon               = 'i5-dependent'

        this.fieldParams.tableCellOnAdd = this.tableCellOnAdd
    }

    tableCellOnAdd = (item: ItemModelV2) => {
        // there should be some universal dependency add modal for all entity types
        const modalAddTaskDependency = () => import('../../../../gd-modals/dependency/task-dependency/task-dependency-modal');

        gd.modal.loadAndShow(modalAddTaskDependency, false, {
            className: 'modal-task-dependency',
            modalType: 'v4',
            toggleCallback: () => {
                // ?????????
            },
            params: {
                taskId: item.task.id,
                parentProjectId: item.task.projectId,
                dependencyType: gd.const.gantt.linkTypes.START_FINISH,
                dependsOn: item.task.predecessors.models,
                dependentTasks: item.task.successors.models,
                onSubmit: (type: DependencyType, task1Id: ID, task2Id: ID)=>{
                    gd.api.Task.addDependency(type, task1Id, task2Id).done(()=>{
                        gd.modal.hide()
                    })
                },
            }
        })
    }
}
